import React from 'react';
import styles from './Calendar.module.scss';
import { getWeekDays } from '@weddingspot/ws-core-components';

const WeekDays = () => {
    return (
        <div className={styles.weekdays}>
            {getWeekDays().map((day) => (
                <span key={day}>{day}</span>
            ))}
        </div>
    );
};

export default WeekDays;
